import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Question } from '../../models/underwriter.model';
import { SidesheetComponent } from '../../components/sidesheet/sidesheet.component';
import { StorageService } from '../../services/storage.service';

/**
 * Shown when the product chosen on the quote page was referred to underwriting. It only renders in that
 * context: the chosen product (stored by the quote page) must carry uw_collation items, otherwise nothing shows.
 */
@Component({
    selector: 'app-question-uw-modal',
    templateUrl: './question-uw-modal.component.html',
    styleUrls: ['./question-uw-modal.component.scss'],
    standalone: false
})
export class QuestionUwModalComponent implements OnInit, OnChanges {

  @ViewChild('uwSidesheet') uwSidesheet: SidesheetComponent;

  @Input() question: Question;
  @Input() readOnly = false;
  @Output() questionAnswer = new EventEmitter<Question>();

  pageInfo: any;
  productSelected: any;
  selectedUwItem: any;
  /** Intro text from uw_collation.sub_header, rendered here because the flow controller has no sub-header element. */
  subHeader = '';
  /** uw_collation items grouped by class, so each class shows once with all its referred items. */
  uwClasses: { class_name: string; img_path: string; items: any[] }[] = [];

  constructor(private storageService: StorageService) {}

  ngOnInit(): void {
    this.productSelected = this.storageService.getJson('selectedProduct', 'flow');
    const uwCollation = this.parseJson(this.productSelected?.uw_collation);
    const items: any[] = uwCollation?.items ?? [];
    if (!items.length) {
      return;
    }

    const rawData = this.storageService.get('quotePageData', 'flow');
    const allData: any[][] = this.parseJson(rawData) ?? [];
    this.pageInfo = allData[1]?.find((item: any) => item.entry_type === 'overview');

    const byClass = new Map<string, { class_name: string; img_path: string; items: any[] }>();
    items.forEach(item => {
      if (!byClass.has(item.class_name)) {
        byClass.set(item.class_name, { class_name: item.class_name, img_path: item.img_path, items: [] });
      }
      byClass.get(item.class_name).items.push(item);
    });
    this.uwClasses = [...byClass.values()];

    const subHeader: string = uwCollation?.sub_header ?? '';
    this.subHeader = subHeader.replace('within 24 hours', '<strong>within 24 hours</strong>');
  }

  openSidesheet(uwItem: any): void {
    this.selectedUwItem = uwItem;
    this.uwSidesheet.open();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes.question.currentValue;
    }
  }

  /** uw_collation arrives as a JSON string from the server but may already be parsed by the quote page. */
  private parseJson(value: any): any {
    if (typeof value !== 'string') {
      return value ?? null;
    }
    try {
      return JSON.parse(value);
    } catch {
      return null;
    }
  }
}
